import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { clearSession, getSession, getToken, saveSession } from "./lib/auth";
import { revokeSession } from "./lib/api";
import { applyDefaultLanguage } from "./lib/i18n";
import { flush, track } from "./lib/events";
import "./lib/activeTime";
import { clearOffline } from "./offline/assetCache";
import { resetBackgroundSync } from "./offline/backgroundSync";
import { flushWrites, initWriteQueue } from "./offline/writeQueue";
import { AppRoutes } from "./routes/AppRoutes";
import type { Session } from "./types";

initWriteQueue();

export default function App() {
  // The whole session lives in state, not just the role: a fresh object on
  // every login guarantees a re-render, where setting a role that happens
  // to match the previous one would be a no-op and strand the login screen.
  const [session, setSession] = useState<Session | null>(getSession());

  return (
    <BrowserRouter>
      <AppRoutes
        session={session}
        onLogin={(value) => {
          saveSession(value);
          applyDefaultLanguage(value.role);
          setSession(value);
          void flush();
          void flushWrites();
        }}
        onLogout={() => {
          track("logout");
          const token = getToken();
          if (token) void revokeSession(token).catch(() => undefined);
          clearSession();
          // Downloaded modules belong to the teacher who signed out. Unsent
          // answers stay queued under their ID and sync at their next login.
          void clearOffline();
          resetBackgroundSync();
          setSession(null);
        }}
      />
    </BrowserRouter>
  );
}
